import { z } from '@harvestiq/zod';
import { RmaLgmTypeCodes, RmaLgmCommodityCodes } from '@harvestiq/constants';

export const lgmCommodityCodeTypeCodePairSchema = z.object({
  commodityCode: z.nativeEnum(RmaLgmCommodityCodes),
  typeCode: z.nativeEnum(RmaLgmTypeCodes),
});

export type LgmCommodityCodeTypeCodePair = z.infer<
  typeof lgmCommodityCodeTypeCodePairSchema
>;
